var _path, _ellipse, _path2, _ellipse2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval22A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 82 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M51 16c7.732 0 14 6.268 14 14s-6.268 14-14 14H31c-7.732 0-14-6.268-14-14s6.268-14 14-14h20Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 73,
  cy: 30,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-180 73 30)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M72 24h1c2.761 0 5 2.686 5 6s-2.239 6-5 6h-1"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 9,
  cy: 30,
  fill: "#464D57",
  rx: 5,
  ry: 6
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M10 36H9c-2.761 0-5-2.686-5-6s2.239-6 5-6h1"
})));
SvgOval22A.viewBox = '0 0 82 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval22A);
export default ForwardRef;